import { IconButton ,Tooltip } from '@mui/material'
import {KeyboardReturn} from '@mui/icons-material'
import React from 'react'
import { useTranslation } from 'react-multi-lang'
import { useNavigate } from 'react-router-dom'
interface iProps {previousPageRoute:string}

export default function Backbutton({previousPageRoute}:iProps) {
    const t =useTranslation()
    const navigate =useNavigate()
  return (

    <IconButton aria-label="delete" onClick={()=>navigate(previousPageRoute)} style={{left:'0px',position:'absolute'}}>
        <Tooltip title={t("back")}> 

       <KeyboardReturn  sx={{color:'var(--primary-color)',fontSize:'2rem'}}/>
        </Tooltip>
     
    </IconButton>
  )
}
